// monorepo/shared/auth/api.js
import api from '../utils/apiRequest';

const AUTH_ENDPOINTS = {
  LOGIN: '/users/login',
  REGISTER: '/users/signup',
  LOGOUT: '/users/logout',
  CHECK_AUTH: '/users/check-auth'
};

export const authService = {
  async login(credentials) {
    return api.post(AUTH_ENDPOINTS.LOGIN, credentials);
  },

  async register(userData) {
    return api.post(AUTH_ENDPOINTS.REGISTER, userData);
  },

  async logout() {
    return api.post(AUTH_ENDPOINTS.LOGOUT);
  },

  async checkAuth() {
    return api.get(AUTH_ENDPOINTS.CHECK_AUTH);
  },

  async getCurrentUser() {
    return api.get(AUTH_ENDPOINTS.CHECK_AUTH);
  }
};

// Export individual functions for convenience
export const getCurrentUser = authService.getCurrentUser;
export const login = authService.login;
export const logout = authService.logout;
export const register = authService.register;
export const checkAuth = authService.checkAuth;